import { useQuery } from '@tanstack/react-query';
import { Endpoints } from '@xver/apis';

export function useAnnouncementsQuery() {
    const { data, isPending, refetch } = useQuery({
        queryKey: ['api.v1.announcements.list'],
        queryFn: async () => Endpoints.v1.Announcements.listAnnouncements(),
        retry: 2,
        retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
        staleTime: 60_000,
    });

    return {
        data: data ?? [],
        isPending,
        refetch,
    };
}
